import { Link, useSearchParams } from "react-router-dom";
import { useState, useRef, useEffect } from "react";
import StrokeTitle from "../components/ui/StrokeTitle";
import BadWords from "../BadWords";
import Button from "../components/ui/Button";
import '../styles/pages/creation.scss'
import Characters from '../character.json';


const Creation = () => {

  const [searchParams, setSearchParams] = useSearchParams();
  const [character, setCharacter] = useState('');
  const [color, setColor] = useState("")

  const [name, setName] = useState(searchParams.get('name') || '');
  const [charClass, setClass] = useState('')
  const [charm, setCharm] = useState(searchParams.get('charm') || '');
  const [disgaeaCharm, setDChar] = useState(searchParams.get('dc') || '');

  const [url, setUrl] = useState('')

  const characters = Characters;

  const [hasBadWords, setBadWords] = useState([])

  const badRef = useRef(null)

  useEffect(()=>{
    setBadWords(
      BadWords.filter(text => name.toLowerCase().includes(text) || disgaeaCharm.toLowerCase().includes(text) || charm.toLowerCase().includes(text)).length
    )
    setUrl(
      {
        name: name,
        character: character,
        color: color,
        charClass: charClass,
        charm: charm,
        disgaeaCharm: disgaeaCharm
      }
    )
  },[disgaeaCharm, charm, name])
  

  return (
    <div className="page-container">
        <StrokeTitle text="Character Profile Creation"/>
        <section className="section-wrapper">
          <h2 className="section-header yellow-text">
            ■ Character
          </h2>
          <ul className="creation-characters">
          {
            characters.filter(char=>(
              char.rank === "1" || char.rank === ""
            )).map(char=>(
              <li>
                <button className={`creation-button ${
                  character===char.id && "selected"
                }`}
                  onClick={()=>{
                    setCharacter(char.id)
                    setColor(char.rank === '' ? '' : parseInt(char.rank))
                    setClass(char.name)
                  }}
                >
                  <img src={
                    char.rank==="generic_46" ? 
                    `${process.env.PUBLIC_URL}/img/character/icon_${char.id}_01.png` :
                    char.rank.includes('generic') ? 
                    `${process.env.PUBLIC_URL}/img/character/icon_${char.id}_01.png` :
                    `${process.env.PUBLIC_URL}/img/character/icon_${char.id}.png`
                  } alt="" />
                </button>
              </li> 
            ))
          }
          <div id="bad-words"></div>
          </ul>
          {
            color !== "" && <>
              <h2 className="section-header yellow-text">
                ■ Rank
              </h2>
              <ul className="creation-characters">
              {
                [...Array(6)].map(
                  (item, i) => (
                    <li>
                      <button className={`creation-button ${
                        color === i+1 &&  "selected"
                      }`}
                      onClick={()=>{
                        setColor(i+1)
                      }}
                    >
                      <img src={
                        `${process.env.PUBLIC_URL}/img/character/icon_${character}_0${i+1}.png`
                      } alt="" />
                      </button>
                    </li> 
                  )
                )
              }
              </ul>
            </>
          }
          {
            hasBadWords > 0 && <div>
              <h4 className="bad-words">
                Please remove any innapropiate language from the fields below!
              </h4>
            </div>
          }
          <h2 className="section-header yellow-text">
            ■ Name
          </h2>
          <input type="text" value={name} className="creation-input" maxLength={32} placeholder="Enter the character's name." onChange={e=>{
            setName(e.target.value)
            BadWords.forEach((word)=>{
              if(name.toLowerCase().includes(word)) {
                setBadWords(word)
              }
            })
          }}/>
          <h2 className="section-header yellow-text">
            ■ Character Charm
          </h2>
          <input type="text" value={charm} className="creation-input" maxLength={80} placeholder="Enter the charm of the character." onChange={e=>{
            setCharm(e.target.value)
            BadWords.forEach((word)=>{
              if(charm.toLowerCase().includes(word)) {
                setBadWords(word)
              }
            })
          }}/>
          <h2 className="section-header yellow-text">
            ■ Disgaea 7 Charm
          </h2>
          <input type="text" value={disgaeaCharm} className="creation-input" maxLength={80} placeholder="Enter the charm of Disgaea 7." onChange={e=>{
            setDChar(e.target.value)
            BadWords.forEach((word)=>{
              if(disgaeaCharm.toLowerCase().includes(word)) {
                setBadWords(word)
              }
            })
          }}/>
        </section>
        <section className="section-wrapper">
          <h2 className="section-header yellow-text">
            ■ Preview
          </h2>
          <div class="preview-image">
            {
              hasBadWords > 0 &&
              <div className="disclaimer">
                Please remove any innapropiate language from the fields above!
              </div>
            }
            <img class="preview-card" src={`${process.env.PUBLIC_URL}/img/img_card.jpg`}/>
            <img class="preview-character-cutin-bg" src={`${process.env.PUBLIC_URL}/img/cutin_bg.jpg`}/>
            <img class="preview-character-cutin-image" src={
              color === "" ?
              `${process.env.PUBLIC_URL}/img/character/ci_${character}.png` :
              `${process.env.PUBLIC_URL}/img/character/ci_${character}_0${color}.png`
            }/>
            <img class="preview-character-cutin-frame" src={`${process.env.PUBLIC_URL}/img/cutin_frame.png`}/>
            <img class="preview-character-wf" src={
              color === "" ?
              `${process.env.PUBLIC_URL}/img/character/wf_${character}.png` :
              `${process.env.PUBLIC_URL}/img/character/wf_${character}_0${color}.png`
            }/>
            <p class="preview-class_name">{charClass}</p>
            <p class="preview-name">{name}</p>
            <p class="preview-text-character">{charm}</p>
            <p class="preview-text-disgaea7">{disgaeaCharm}</p>
          </div>
          <a href={
            hasBadWords === 0 ? 
            `${process.env.PUBLIC_URL}/creation/share?data=${btoa(JSON.stringify(url))}` :
            "#bad-words"
        } target="" rel="noopener">
            <Button text="Create" color="green"/>
          </a>
        </section>
    </div>
  )
}

export default Creation;